import { reducers as scsReducers } from '@racepointenergy/swc'

import { AUTH_REDUCER_NAME } from 'features/auth/login/consts'
import { ROOT_DOMAINS_REDUCER_NAME } from 'features/rootDomains/consts'
import { DOMAINS_REDUCER_NAME } from 'features/domains/consts'
import { HOME_REDUCER_NAME } from 'features/home/consts'
import { TEMPLATES_REDUCER_NAME } from 'features/templates/consts'
import { PROFILES_REDUCER_NAME } from 'features/profiles/consts'
import { LICENSES_REDUCER_NAME } from 'features/licenses/consts'
import { TEAM_REDUCER_NAME } from 'features/team/consts'
import { JOB_REDUCER_NAME } from 'features/jobs/consts'
import { PAYMENT_METHODS_REDUCER_NAME } from 'features/paymentMethods/consts'
import { AUDIT_LOGS_REDUCER_NAME } from 'features/audit/consts'
import { BILLING_HISTORY_REDUCER_NAME } from 'features/billingHistory/consts'
import { ASIDE_CONST } from 'features/aside/consts'
import { NETWORK_AI_REDUCER_NAME } from 'features/networkAi/consts'

import authReducer from 'features/auth/login/reducer'
import domainsReducer from 'features/domains/reducer'
import homeReducer from 'features/home/reducer'
import templatesReducer from 'features/templates/reducer'
import profilesReducer from 'features/profiles/reducer'
import licensesReducer from 'features/licenses/reducer'
import teamReducer from 'features/team/reducer'
import rootDomainsReducer from 'features/rootDomains/reducer'
import jobReducer from 'features/jobs/reducer'
import { paymentMethodsReducer } from 'features/paymentMethods/reducer'
import auditReducer from 'features/audit/reducer'
import billingHistoryReducer from 'features/billingHistory/reducer'
import asideReducer from 'features/aside/slice'
import networkAIReducer from 'features/networkAi/reducer'

export const reducers = {
  [AUTH_REDUCER_NAME]: authReducer,
  [ROOT_DOMAINS_REDUCER_NAME]: rootDomainsReducer,
  [DOMAINS_REDUCER_NAME]: domainsReducer,
  [HOME_REDUCER_NAME]: homeReducer,
  [TEMPLATES_REDUCER_NAME]: templatesReducer,
  [PROFILES_REDUCER_NAME]: profilesReducer,
  [LICENSES_REDUCER_NAME]: licensesReducer,
  [TEAM_REDUCER_NAME]: teamReducer,
  [JOB_REDUCER_NAME]: jobReducer,
  [PAYMENT_METHODS_REDUCER_NAME]: paymentMethodsReducer,
  [AUDIT_LOGS_REDUCER_NAME]: auditReducer,
  [BILLING_HISTORY_REDUCER_NAME]: billingHistoryReducer,
  [ASIDE_CONST]: asideReducer,
  [NETWORK_AI_REDUCER_NAME]: networkAIReducer,
  ...scsReducers,
}
